import { render, staticRenderFns } from "./Intelligent-matching.vue?vue&type=template&id=7c0c42d6&scoped=true&"
import script from "./Intelligent-matching.vue?vue&type=script&lang=js&"
export * from "./Intelligent-matching.vue?vue&type=script&lang=js&"
import style0 from "./Intelligent-matching.vue?vue&type=style&index=0&id=7c0c42d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0c42d6",
  null
  
)

export default component.exports